import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getBulkList,
  getDeliveryPercentList,
  getGoogleSheet,
  getSymbolList,
} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { useNavigate } from "react-router-dom";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { AIPromptForStock1 } from "../utils/constants";

const BulkDealsPage = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [bulkDealsData, setBulkDealsData] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const [series, setSeries] = useState('EQ');
  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  const [startDate, setStartDate] = useState(new Date());
  const [deliveryDataList, setDeliveryDataList] = useState([]);
  const userToken = useSelector((state) => state.userToken.value);
  const navigate = useNavigate();


  useEffect(() => {
  if (!userToken) {
    navigate(`/`);
    return;
  }

  let current_date = moment(startDate).format("DDMMYY");

  setLoader(true);

  Promise.all([
    getBulkList("", userToken),
    getSymbolList(series, '', userToken),
    getGoogleSheet("", userToken),
    getDeliveryPercentList('', 'bulk', '', '', series, '', userToken)
  ])
    .then(([bulkRes, symbolRes, sheetRes, delivery]) => {
      setBulkDealsData(bulkRes?.data?.data || []);
      setSymbolData(symbolRes?.data?.data || []);
      setTodayData(sheetRes?.data?.data?.json_data || []);
      setDeliveryDataList(delivery?.data.data);
      dispatch(setDeliveryDataReducer(delivery?.data.data));
    })
    .catch((err) => {
      console.log("Error", err);
    })
    .finally(() => {
      setLoader(false);
    });

}, [startDate, userToken]);

  const symbolCountMap = {};
  let totalPL = 0;
  let checkHavingRecord = [];

  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === true ? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table className="increaseOI table-responsive">
              <thead>
                <tr>
                  <th style={{ width: "180px" }}>Symbol [{Object.entries(bulkDealsData)?.length}]</th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "40px", textAlign: "left" }}>Score</th>
                  <th style={{ width: "40px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "40px", textAlign: "left" }}>Series</th>
                  <th style={{ width: "140px", textAlign: "left"}}>Sector</th>
                  <th style={{ width: "180px", textAlign: "left"}}>ClientName</th>
                  <th style={{ width: "40px", textAlign: "left" }}>Indices</th>
                  <th style={{ width: "50px" }}>Buy/Sell</th>
                  <th style={{ width: "50px" }}>Quantity</th>
                  <th style={{ width: "52px" }}>In Crore</th>
                  <th style={{ width: "52px" }}>Turn%</th>
                  <th style={{ width: "50px" }}>Price</th>
                  <th style={{ width: "50px" }}>LTP</th>
                  <th style={{ width: "50px" }}>Chn%</th>
                  <th style={{ width: "50px" }}>Tchn%</th>
                  <th style={{ width: "50px" }}>SMA200</th>
                  <th style={{ width: "70px" }}>52 Down</th>
                  <th style={{ width: "60px" }}>52 L/H</th>
                  <th style={{ width: "75px" }}>AT Vol</th>
                  <th style={{ width: "50px" }}>Del %</th>
                  <th style={{ width: "30px" }}>News</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(bulkDealsData)?.map((item, index) => {
                  return (
                    <React.Fragment>
                      <tr key={`item_b_${index}`}>
                        <th style={{ backgroundColor: "#e9e9e9" }} colSpan={16}>
                          {moment(item[0]).format("DD/MM/YYYY")}
                        </th>
                        <th
                          style={{
                            backgroundColor: "#e9e9e9",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: totalPL > 0 ? "#159b00" : "#F00",
                          }}
                        >
                          {index > 0 && totalPL !== 0
                            ? totalPL.toFixed(2) + "%"
                            : ""}
                        </th>
                        <th
                          style={{ backgroundColor: "#e9e9e9" }}
                          colSpan={6}
                        ></th>
                      </tr>
                      {Object.entries(item[1])?.map((obj, ind) => {
                        // if((((obj[1].buy_count) - (obj[1].sell_count)) >= 0)  && (((obj[1].buy_quantity) - (obj[1].sell_quantity)) > 10000)){
                        if (ind === 0) {
                          totalPL = 0;
                        }
                        const symbolName = obj[0];
                        let bulkDate = obj[1].trades[0].date;

                        let filterSymbol = symbolData.find(
                          (item, index) =>
                            item.symbol === symbolName && item.MarketCap > 500
                        );
                        let todayLTP = todayData.find(
                          (item, index) => item.TICKER === symbolName
                        );

                        let LTP = todayLTP?.LTP !== "#N/A" && !Number.isNaN(Number(todayLTP?.LTP)) ? todayLTP?.LTP : 0;


                        let deliverylist = Object.values(deliveryDataList);
                        let deliveryData = deliverylist?.find((s) => s.symbol === symbolName);
              

                        if (filterSymbol) {
                          let prevVolume = (
                            ((parseInt(deliveryData?.stock_data[0]?.ttl_trd_qty) -
                              parseInt(deliveryData?.stock_data[1]?.ttl_trd_qty)) *
                              100) /
                            parseInt(deliveryData?.stock_data[1]?.ttl_trd_qty)
                          ).toFixed(2);

                          let incrore = (
                            ((obj[1].buy_quantity - obj[1]?.sell_quantity) *
                              obj[1].trades[0].tradePrice) /
                            10000000
                          ).toFixed(2);

                          let tchn = LTP > 0? ((LTP - obj[1].trades[0].tradePrice) * 100) / obj[1].trades[0].tradePrice : 0;

                          totalPL = totalPL + tchn;

                          if (ind >= 0) {
                            checkHavingRecord.push(ind);
                          }


                          return (
                            <tr
                              className={`tr_${filterSymbol?.id}`}
                              key={ind}
                              id={`row_item_${index + 1}_${ind + 1}`}
                            >
                              <td
                                id={`item_${index + 1}_${ind + 1}`}
                                className={`symbolName ${obj[1].in_watchlist ==='1'? 'inwatchlist':''}`}
                                style={{
                                  backgroundColor:
                                    obj[1].count > 1
                                      ? `rgba(45, 130, 45, 0.${obj[1].count}`
                                      : "",
                                }}
                              >
                                {symbolName}{" "}
                                {`${
                                  obj[1].count > 1
                                    ? "(" + obj[1].count + ")"
                                    : ""
                                }`}

                                {filterSymbol?.hotStar === "1" ? (
                                      <span className="hotStar"></span>
                                      ) : null}

                                      
                              </td>
                              <td>
                                <StockAction
                                  symbol={symbolName}
                                  delivery={false}
                                  currentPrice={obj[1].trades[0].tradePrice}
                                  deliveryPer={deliveryData?.delivery_per}
                                  hotStar={filterSymbol?.hotStar}
                                  myFev={filterSymbol?.myFev}
                                  eventName="Bulk"
                                  rowId={`row_item_${index + 1}_${ind + 1}`}
                                  score={deliveryData?.score}
                                />
                              </td>
                              <td>
                                <DeliveryGraph
                                  symbol={symbolName}
                                  todayLTP={todayLTP}
                                  date={moment(
                                    NSE_Past_date[0]?.max_date
                                  ).format("YYYY-MM-DD")}
                                />
                              </td>
                              <td>{deliveryData?.score}</td>
                              <StockStrength
                                id={`bulk_${index + 1}_${ind + 1}`}
                                selectedDate={startDate}
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                details={filterSymbol}
                              />
                              <td style={{ textAlign: "left" }}>
                                {filterSymbol?.series}
                              </td>
                              {/* <td style={{textAlign:'left'}}>{obj[1].trades[0].securityName}</td> */}
                              <SectorPanchang
                                symbol={symbolName}
                                sector={filterSymbol?.group_sector}
                                todayData={todayData}
                                symbolData={symbolData}
                                tag = "td"
                                align = "right"
                                durationDays = ""
                              />

                              <td
                                style={{ textAlign: "left", lineHeight: "1.1" }}
                              >
                                {obj[1].trades[0]?.clientName}
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {(() => {
                                  const label = filterSymbol?.nifty50
                                    ? "50"
                                    : filterSymbol?.nifty100
                                    ? "100"
                                    : filterSymbol?.nifty200
                                    ? "200"
                                    : filterSymbol?.nifty500
                                    ? "500"
                                    : filterSymbol?.totalMarket
                                    ? "TM"
                                    : "";
                                  const excludedSeries = ["ETF", "BOND", "MF"];
                                  const showFev =
                                    filterSymbol?.myFev &&
                                    !excludedSeries.includes(
                                      filterSymbol?.series
                                    );
                                  return (
                                    label +
                                    (showFev ? `${label ? ", " : ""}Fev` : "")
                                  );
                                })()}
                              </td>
                              <td>{obj[1].buy_count - obj[1].sell_count}</td>
                              <td>
                                {obj[1].buy_quantity - obj[1].sell_quantity}
                              </td>
                              <td
                                style={{
                                  background:
                                    obj[1].buy_count - obj[1].sell_count > 0 &&
                                    incrore >= 2
                                      ? "#b0e1ad"
                                      : "#FFF",
                                }}
                              >
                                {incrore}
                              </td>
                              <td>
                                {(
                                  (parseFloat(incrore) /
                                    parseInt(filterSymbol?.MarketCap)) *
                                  100
                                ).toFixed(2)}
                              </td>
                              <td>{obj[1].trades[0].tradePrice}</td>
                              <td
                                title={
                                  todayLTP?.DATETIME && todayLTP.DATETIME !== "#N/A"
                                    ? moment(todayLTP?.DATETIME).format("DD/MM/YY HH:mm")
                                    : null
                                }
                                style={{
                                  color:
                                    LTP > obj[1].trades[0].tradePrice
                                      ? "#1c8b16"
                                      : "#f00",
                                }}
                              >
                                {LTP}
                              </td>
                              <td>{ (todayLTP?.CHANGEPER !== "#N/A" &&  !Number.isNaN(Number(todayLTP?.LTP)))? todayLTP?.CHANGEPER: 0}%</td>
                              <td
                                style={{
                                  color: tchn > 0 ? "#1c8b16" : "#f00",
                                }}
                              >
                                {tchn.toFixed(2)}%
                              </td>
                              
                              <td
                                style={{
                                  textAlign: "right",
                                  background:
                                    parseFloat(deliveryData?.SMA50) >
                                    parseFloat(deliveryData?.SMA200)
                                      ? "#e2ffe5"
                                      : "#fff8f8",
                                }}
                                title={`SMA50: ${deliveryData?.SMA50}`}
                              >
                                {deliveryData?.SMA200}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {filterSymbol?.high52w
                                  ? (
                                      ((filterSymbol?.high52w -
                                        obj[1].trades[0].tradePrice) *
                                        100) /
                                      filterSymbol?.high52w
                                    ).toFixed(2)
                                  : ""}
                                %
                              </td>
                              <td
                                title={`${moment(filterSymbol?.lowDate).format(
                                  "DD-MM-YY"
                                )} / ${moment(filterSymbol?.highDate).format(
                                  "DD-MM-YY"
                                )}`}
                              >
                                {filterSymbol?.low52w}
                                {filterSymbol ? "/" : ""}
                                {filterSymbol?.high52w}
                              </td>
                              <td>{ (todayLTP?.VOLUME !== "#N/A" &&  !Number.isNaN(Number(todayLTP?.VOLUME)))? parseInt(todayLTP?.VOLUME).toLocaleString("en-IN"): 0}</td>
                              <td
                                className={prevVolume > 100? "datrcolor" : ""}
                                title={`${Number(deliveryData?.avgVolume).toLocaleString("en-IN")}`}
                              >
                                {deliveryData?.stock_data[0].delivery_per}%
                              </td>
                              <td>
                                <a
                                  className="newsicon"
                                  // href={`https://www.google.com/search?q=NSE:${symbolName}+share+bulk+deals+on+${moment(
                                  //   bulkDate
                                  // ).format("Do+MMMM+YYYY")}`}
                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(symbolName)}`}
                                  target="_blank"
                                ></a>
                              </td>
                            </tr>
                          );
                        }

                        // }
                      })}
                    </React.Fragment>
                  );
                })}

                <tr key={`item_1`}>
                  <th style={{ backgroundColor: "#e9e9e9" }} colSpan={16}>
                    {" "}
                  </th>
                  <th
                    style={{
                      backgroundColor: "#e9e9e9",
                      textAlign: "right",
                      fontWeight: "bold",
                      color: totalPL > 0 ? "#159b00" : "#F00",
                    }}
                  >
                    {totalPL !== 0 ? totalPL.toFixed(2) + "%" : ""}
                  </th>
                  <th style={{ backgroundColor: "#e9e9e9" }} colSpan={6}></th>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default BulkDealsPage;
